module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-hero.5473f947.jpg";